import React, { useEffect, useRef, useState } from "react";
import {
  setRecomandModal,
  setSelectedAd,
  setTooltipOpen,
} from "../../../redux/slices/LcaSlice";
import { Button } from "reactstrap";
import { FaUser } from "react-icons/fa";
import { MdGroups } from "react-icons/md";
import { useDispatch, useSelector } from "react-redux";
import "./LcaCards.css";
import "moment-timezone/builds/moment-timezone-with-data";
import { UncontrolledTooltip } from "reactstrap";
import { BsInfoCircleFill } from "react-icons/bs";
import {
  checkExisting,
  handleActionClick,
  setActionType,
  setIsChatModalOpen,
  setSampleAd,
  setSearchPopUp,
} from "../../../redux/slices/SearchBarSlice";
import { setEngagedCouple } from "../../../redux/slices/RequestFormSlice";
import { toast } from "react-toastify";
import { initiateCall } from "../Data";

const LcaActionButtons = ({
  ad,
  handleIndiviualCall,
  toggleEvents,
  toggleQuestions,
  openOfferModal,
  handleSkip,
  buttonRef,
  tooltipRef,
  timeLeft,
  questionsVisible,
  eventsVisible,
}) => {
  const dispatch = useDispatch();
  const islogin = useSelector((state) => state.user.isLogin);
  const userdata = useSelector((state) => state.user);
  const userinfo = useSelector((state) => state.user.userInfo);
  const user = islogin ? JSON.parse(userinfo) : null;
  const { sampleAd, generatedNeedId } = useSelector((state) => state.searchBar);
  const { selectedAd, gottonData, tooltipOpen, recomandModal } = useSelector(
    (state) => state.lcAds
  );
  const isAdmin = user && user.Role === "admin";
  const logUser = localStorage.getItem("USER_ROLE");
  const isVendor = logUser === "provider";
  const [phoneButton, setPhoneButton] = useState("Show Phone Number");

  useEffect(() => {
    if (ad.Id === generatedNeedId) {
      setPhoneButton(`(800)245-3610 Ext# ${ad.dialExtension}`);
    }
  }, [generatedNeedId, sampleAd]);
  const isAdInMyOffers = (ad) => {
    const offers = ad?.approveProviderId;
    const parseIds = offers?.split(",").map(Number);
    return parseIds?.includes(user?.UserID);
  };

  const isAlreadyGotton = (ad) => {
    const offers = ad?.approveProviderId;
    const parseIds = offers?.split(",").map(Number);
    return parseIds?.length >= 5;
  };
  const handleRecomend = (event, ad) => {
    event.stopPropagation();
    dispatch(setSelectedAd(ad));
    dispatch(setRecomandModal(true));
  };
  const handleAction = async (event, action) => {
    event.stopPropagation();
    dispatch(setSampleAd(ad));
    dispatch(setActionType(action));
    let needExists = false;
    if (islogin) {
      const constructedTitle = ad?.Title + " (Auto Generated)";
      const checkForm = {
        Title: constructedTitle,
        userId: user.UserID,
      };
      const result = await dispatch(checkExisting(checkForm)).unwrap();
      needExists = result.data;
    }
    if (isAdmin || isVendor || needExists) {
      setPhoneButton(`(800)245-3610 Ext# ${ad.dialExtension}`);
      if (action === "CALL") {
        const phoneNumber = selectedAd?.Phone;
        const url = `tel:${phoneNumber}`;
        window.location.href = url;
      } else if (action === "TEXT") {
        console.log(action, "action");
        dispatch(setIsChatModalOpen(true));
      } else if (action === "VISIT") {
        window.open(ad.websiteLink, "_blank");
      }
      return;
    }
    if (islogin) {
      const actionForm = {
        userId: user.UserID,
        postId: ad.Id,
        postType: 1,
        clickType: action === "CALL" ? 1 : action === "TEXT" ? 2 : 3,
        createdBy: user.UserID,
      };
      dispatch(handleActionClick(actionForm));
    }

    dispatch(setSearchPopUp(true));
    dispatch(setEngagedCouple(0));
  };
  const handleGroupCall = async (ad) => {
    const ID = ad?.Id;
    const phoneDetailsObj = [
      {
        email: ad?.Email,
        phoneNumber: ad?.Phone,
        countryCode: ad?.countryCode,
      },
      {
        email: "",
        phoneNumber:
          ad?.alternativePhoneOne === null || ad?.alternativePhoneOne === ""
            ? ""
            : ad?.alternativePhoneOne,
        countryCode:
          ad?.alternativePhoneOne === null || ad?.alternativePhoneOne === ""
            ? ""
            : ad?.countryCode,
      },
      {
        email: "",
        phoneNumber:
          ad?.alternativePhoneTwo === null || ad?.alternativePhoneTwo === ""
            ? ""
            : ad?.alternativePhoneTwo,
        countryCode:
          ad?.alternativePhoneTwo === null || ad?.alternativePhoneTwo === ""
            ? ""
            : ad?.countryCode,
      },
      {
        email: user?.Email,
        phoneNumber: user?.Phone,
        countryCode: user?.CountryCode,
      },
    ];
    const phoneDetails = JSON.stringify(phoneDetailsObj);
    let formData = {
      phoneDetails: phoneDetails,
      email: user?.Email,
    };
    toast.success("Group Call Started");
    await initiateCall(formData);
  };
  return (
    <>
      {ad.engagedCouple == 1 && (
        <div className="w-100 text-center engagedCouple">
          {isAdInMyOffers(ad) ? (
            <>
              <span className="dropdown-center">
                <Button
                  color="success"
                  size="sm"
                  className="dropdown-toggle w-100 mb-2"
                  data-bs-toggle="dropdown"
                  aria-expanded="false"
                >
                  Call Me
                </Button>
                <ul
                  className="dropdown-menu dropdown-menu-center"
                  style={{ cursor: "pointer" }}
                >
                  <li>
                    <a
                      class="dropdown-item text-center fw-bold"
                      onClick={() => handleIndiviualCall(ad)}
                    >
                      Individual Call <FaUser />
                    </a>
                  </li>
                  <li>
                    <a
                      class="dropdown-item text-center fw-bold"
                      onClick={() => handleGroupCall(ad)}
                    >
                      Group Call <MdGroups size={20} />
                    </a>
                  </li>
                </ul>
              </span>
              <Button
                color="primary"
                size="sm"
                className="w-100 mb-2"
                onClick={(event) => handleAction(event, "TEXT")}
              >
                Send message
              </Button>
            </>
          ) : isAlreadyGotton(ad) ? (
            <Button color="primary" size="xs" className="w-100 mb-2" disabled>
              Other venues took customer
            </Button>
          ) : +gottonData?.totalMessages >= +gottonData?.getCustomerLimit ? (
            <Button className="w-100 mb-2" color="primary" disabled>
              Monthly Limit Exceeded
            </Button>
          ) : (
            <>
              <Button
                color="primary"
                size="sm"
                className="w-100 mb-2"
                onClick={(event) => openOfferModal(event, ad)}
              >
                Get Customer!
                <br />
                {islogin && (
                  <>
                    {timeLeft === "00:00:00" ? (
                      <p
                        className="text-white m-0 text-nowrap"
                        style={{ fontSize: "12px" }}
                      >
                        Late Fee $10
                      </p>
                    ) : (
                      <div className="d-flex align-items-center justify-content-center">
                        <p
                          className="m-0"
                          style={{
                            fontSize: "small",
                            color: "white",
                            textWrap: "nowrap",
                          }}
                        >
                          {timeLeft === "00:00:00"
                            ? `Time's Up: ${timeLeft}`
                            : `Time left: ${timeLeft}`}
                        </p>
                        <button
                          id="ScheduleUpdateTooltip"
                          ref={buttonRef}
                          className="ms-2 position-relative"
                          style={{
                            backgroundColor: "inherit",
                            color: "white",
                          }}
                          onClick={(e) => {
                            e.stopPropagation();
                            setTimeout(() => {
                              dispatch(setTooltipOpen(true));
                            }, 0);
                          }}
                        >
                          <BsInfoCircleFill size={17} />
                        </button>
                        <UncontrolledTooltip
                          placement="top"
                          target="ScheduleUpdateTooltip"
                          trigger="click"
                          isOpen={tooltipOpen}
                          toggle={() => dispatch(setTooltipOpen(false))}
                          container="body"
                          innerRef={tooltipRef}
                        >
                          Free during 24-hour timer, $10 late fee applies after
                        </UncontrolledTooltip>
                      </div>
                    )}
                  </>
                )}
              </Button>
              {(isVendor || isAdmin) && (
                <Button
                  color={ad?.needSkipCustomer == 1 ? "secondary" : "danger"}
                  size="sm"
                  className="w-100 mb-2"
                  onClick={(e) => handleSkip(e, ad)}
                >
                  {ad?.needSkipCustomer == 1 ? "Unskip" : "Skip"}
                </Button>
              )}
            </>
          )}
          <Button
            color={questionsVisible[ad.Id] ? "secondary" : "warning"}
            size="sm"
            className="w-100 mb-2"
            onClick={(event) => toggleQuestions(event, ad)}
          >
            {questionsVisible[ad.Id] ? "Hide Q&A" : "Show Q&A"}
          </Button>
          <Button
            color={eventsVisible[ad.Id] ? "secondary" : "success"}
            size="sm"
            className="w-100 mb-2"
            onClick={(event) => toggleEvents(event, ad)}
          >
            {eventsVisible[ad.Id] ? "Hide Event Details" : "Show Event Details"}
          </Button>
          {isAdmin && (
            <Button
              color="info"
              size="sm"
              className="w-100 mb-2"
              onClick={(event) => handleRecomend(event, ad)}
            >
              Recomend
            </Button>
          )}
        </div>
      )}
      {ad.engagedCouple != 1 && ad?.checkedValue === "mobile" ? (
        <div className="w-100 text-center need">
          <button
            className="btn btn-success btn-sm mb-2 w-100"
            onClick={(event) => handleAction(event, "CALL")}
          >
            {phoneButton}
          </button>
          <Button
            color="primary"
            size="sm"
            className="w-100 mb-2"
            onClick={(event) => handleAction(event, "TEXT")}
          >
            Send Message
          </Button>
          {isAdmin && (
            <Button
              color="info"
              size="sm"
              className="w-100 mb-2"
              onClick={(event) => handleRecomend(event, ad)}
            >
              Recomend
            </Button>
          )}
        </div>
      ) : (
        ad.engagedCouple != 1 &&
        ad?.checkedValue === "website" && (
          <button
            className={`btn btn-sm`}
            style={{ backgroundColor: "#99d9ea" }}
            onClick={(event) => handleAction(event, "VISIT")}
          >
            <a
              target="_blank"
              className="text-dark"
              style={{
                fontSize: "15px",
                fontWeight: "600",
                padding: "3px 7px",
              }}
            >
              Visit Webpage
            </a>
          </button>
        )
      )}
    </>
  );
};

export default LcaActionButtons;
